<template>
   <div id="flight-lazy-load">
      <span> {{ $t("flightLazyLoad_lblLazyLoad") }}</span>

      <lottie-animation :speed="0.75" path="assets/animations/lazyLoad.json" />
   </div>
</template>

<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
export default {
   name: "FlightLazyLoad",
   components: {
      LottieAnimation,
   },
};
</script>

<style lang="scss" scoped>
#flight-lazy-load {
   position: fixed;
   bottom: 1.5rem;
   left: 0;
   right: 0;
   margin: auto;
   width: 160px;
   padding: 0.5rem 1rem;
   border-radius: 3rem;
   //background-color: var(--gray-50);
   background-color: var(--gray-0);
   border: 1px solid var(--gray-300);
   z-index: 99;
   animation: flight-pulse-bg 0.5s infinite alternate;
   span {
      font-weight: 600;
      color: var(--primary);
      width: 100%;
      display: block;
      text-align: center;
   }
   @media (min-width: 992px) {
      width: 200px;
      bottom: 1.5rem;
   }

   @keyframes flight-pulse-bg {
      0% {
         //background-color: var(--gray-50);
         background-color: var(--gray-0);
      }
      50% {
         background-color: var(--gray-200);
      }
      100% {
         //background-color: var(--gray-50);
         background-color: var(--gray-0);
      }
   }
}
</style>
